import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "bba0b902-6856-4770-a0cf-c2b4a26af156"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterBba0b90268564770A0cfC2b4a26af156(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterBba0b90268564770A0cfC2b4a26af156 footer`}>
      {props["links"] || <Navigation className="Links9ad4fb0fFa2142ca84f9C63e87a86ffe" parentTag={buildClassName("Links9ad4fb0fFa2142ca84f9C63e87a86ffe", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoE9765cc7147d4092Afc3Cab4f74d43fb" parentTag={buildClassName("LogoE9765cc7147d4092Afc3Cab4f74d43fb", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright7ee519596ece43a0Bc3aC0e6dd3a2468" parentTag={buildClassName("Copyright7ee519596ece43a0Bc3aC0e6dd3a2468", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowF1a09fb4951741bd826030b4ca47f933" parentTag={buildClassName("GroupflowF1a09fb4951741bd826030b4ca47f933", parentTag)} {...props} />}
    </footer>
  );
}

// id: "9ad4fb0f-fa21-42ca-84f9-c63e87a86ffe"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "bba0b902-6856-4770-a0cf-c2b4a26af156"
export function Links9ad4fb0fFa2142ca84f9C63e87a86ffe(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links9ad4fb0fFa2142ca84f9C63e87a86ffe" parentTag={buildClassName("Links9ad4fb0fFa2142ca84f9C63e87a86ffe", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "e9765cc7-147d-4092-afc3-cab4f74d43fb"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "bba0b902-6856-4770-a0cf-c2b4a26af156"
export function LogoE9765cc7147d4092Afc3Cab4f74d43fb(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoE9765cc7147d4092Afc3Cab4f74d43fb" parentTag={buildClassName("LogoE9765cc7147d4092Afc3Cab4f74d43fb", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "7ee51959-6ece-43a0-bc3a-c0e6dd3a2468"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "bba0b902-6856-4770-a0cf-c2b4a26af156"
export function Copyright7ee519596ece43a0Bc3aC0e6dd3a2468(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright7ee519596ece43a0Bc3aC0e6dd3a2468" parentTag={buildClassName("Copyright7ee519596ece43a0Bc3aC0e6dd3a2468", parentTag)} {...props} />
  );
}

// id: "f1a09fb4-9517-41bd-8260-30b4ca47f933"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "bba0b902-6856-4770-a0cf-c2b4a26af156"
export function GroupflowF1a09fb4951741bd826030b4ca47f933(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowF1a09fb4951741bd826030b4ca47f933" parentTag={buildClassName("GroupflowF1a09fb4951741bd826030b4ca47f933", parentTag)} {...props} />
  );
}

// id: "8c27482c-972d-469d-bbc5-1bfb1f9073be"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "e9765cc7-147d-4092-afc3-cab4f74d43fb"
export const LogoType8c27482c972d469dBbc51bfb1f9073be = "FOOTER";

// id: "3aecb469-9b77-4945-8831-98152d9da316"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "9ad4fb0f-fa21-42ca-84f9-c63e87a86ffe"
export const NavMenuSlug3aecb4699b774945883198152d9da316 = "footer-nav";

// id: "7e23996c-92c5-49ed-9725-59b639e9089d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e9765cc7-147d-4092-afc3-cab4f74d43fb"
export const ContentSlug7e23996c92c549ed972559b639e9089d = "footer-logo";

const Components = {
  DefaultFooterBba0b90268564770A0cfC2b4a26af156,
  Links9ad4fb0fFa2142ca84f9C63e87a86ffe,
  LogoE9765cc7147d4092Afc3Cab4f74d43fb,
  Copyright7ee519596ece43a0Bc3aC0e6dd3a2468,
  GroupflowF1a09fb4951741bd826030b4ca47f933,
  LogoType8c27482c972d469dBbc51bfb1f9073be,
  NavMenuSlug3aecb4699b774945883198152d9da316,
  ContentSlug7e23996c92c549ed972559b639e9089d
}

export default Components;